import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IViewBase } from '../../../../ts/models/IViewInfo';
import { whoHasSeenThisView } from '../../../actions/spaces/WhoHasSeenThisViewAction';
import { SessionSiteSelectors, SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { getOwnerIdForView } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { IWhoHasSeenThisViewAction } from '../../../../ts/ServerApi/types/actionNames';
import { SiteRolesUtil } from '../../../../userManagement/services/resources/SiteRolesUtil';

export const WhoHasSeenThisViewEntityAction: IEntityAction<IContentInfo | IViewBase, IWhoHasSeenThisViewAction> = {
  name: EntityActionNames.WhoHasSeenThisView,
  translateName: Messages.whoHasSeenThisView,
  isVisible: (targetItems: IContentInfo[]) => targetItems.length === 1,
  isClickable: (availableActions: IWhoHasSeenThisViewAction, targetItems: IContentInfo[] | IViewBase[], state: AppState) => {
    return (SessionUserSelectors.isSessionServerAdmin(state) ||
      SiteRolesUtil.isSiteAdmin(SessionSiteSelectors.siteRole(state)) ||
      getOwnerIdForView(targetItems[0]) === SessionUserSelectors.sessionUserId(state))
      && (availableActions && availableActions.whoHasSeenThisView);
  },
  createReduxAction: (targetItems: IContentInfo[]) => whoHasSeenThisView(targetItems[0])
};
